export enum AssetsEnum {
  ATTESTATION_RGPD = "CONSENTEMENT_RGPD",
  NOTICE_UTILISATION = "NOTICE_UTILISATION",
  NOTICE_ADMINISTRATION = "NOTICE_ADMINISTRATION",
  DOCUMENTS_RGPD = "DOCUMENTS_RGPD",
  MODELE_IMPORT_DOSSIERS = "MODELE_IMPORT_DOSSIERS",
  DOCUMENTATION_IMPORT_DOSSIERS = "DOCUMENTATION_IMPORT_DOSSIERS",
  ACCORD_OPPOSITION_PARTAGE = "ACCORD_OPPOSITION_PARTAGE"
}